// frontend/src/api/permit.api.js
import apiClient from "./client.js";

export const getPermits = (params = {}) =>
  apiClient.get("/permits", { params }).then((r) => r.data.data);
